import { useAppSelector } from 'store/hooks';
import { selectGlobalInfo } from 'store/slices/globalInfoSlice';
import { selectUserInfo } from 'store/slices/userInfoSlice';
import { useMemo } from 'react';

const useCurrentShopStaffs = () => {
  const { isLoading, shop, subShop } = useAppSelector(selectUserInfo);
  const { staffSelectOptions } = useAppSelector(selectGlobalInfo);

  const allShopIdList = useMemo(() => {
    return [shop, ...subShop].filter((i) => i !== undefined);
  }, [shop, subShop]);

  if (isLoading) return [];

  // 对于没有所属店铺的账号，返回所有的工作人员
  if (!allShopIdList.length)
    return staffSelectOptions.filter((i) => i.status === 1);

  return staffSelectOptions
    .filter((i) => i.status === 1)
    .filter((i) => {
      if (i.shop && allShopIdList.includes(i.shop)) {
        return true;
      }
      if (i.subShop && i.subShop.some((j) => allShopIdList.includes(j))) {
        return true;
      }
      return false;
    });
};

export default useCurrentShopStaffs;
